import(/* webpackMode: "eager", webpackExports: ["LocalizationSimulator"] */ "/home/runner/work/udata-site/udata-site/components/Navigation/Simulator/LocalizationSimulator.tsx");
